import {
	EXPORT_FEEDBACKS,
	EXPORT_FEEDBACKS_SUCCESS,
	EXPORT_FEEDBACKS_FAIL,
	EXPORT_FEEDBACKS_RESET,
} from '../actions/exportFeedbacksAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const exportFeedbacksReducer = (state = initialState, action) => {
	switch (action.type) {
		case EXPORT_FEEDBACKS:
			return {
				...state,
				apiState: 'loading',
			};
		case EXPORT_FEEDBACKS_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case EXPORT_FEEDBACKS_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case EXPORT_FEEDBACKS_RESET:
			return initialState;
		default:
			return state;
	}
};

export default exportFeedbacksReducer;
